export default __webpack_public_path__ + "./fonts/profile.5558965d.svg";